// Cylinder labels (Phase 3): the data a printed QR label carries, aligned with the backend's src/modules/cylinders
// (POST /cylinders/labels, GET /cylinders/:id/label). The QR's payload is the serial exactly, never a URL.
import { api, send } from './client';

export interface CylinderLabel {
  id: number;
  serialNo: string;
  /** = the serial number exactly (the backend's answer is encoded as is) */
  qrPayload: string;
  /** the maker's own serial, printed small under the system serial when known */
  manufacturerSerial: string | null;
}
/** The owner (ORG_NAME) and the programme printed on every label of the batch. */
export interface CylinderLabelBatch { ownerName: string; programName: string; labels: CylinderLabel[] }

/** At most this many labels per request (= the backend's ORDERS.labelBatchMax). */
export const LABELS_MAX = 200;
/** cylinder-identify.service.ts › CylinderLabel */
interface WireLabel { cylinderId: number; serialNo: string; qrPayload: string; manufacturerSerial: string | null; kind: string; capacity: string | null; ownerName: string; programName: string }
const toBatch = (items: WireLabel[]): CylinderLabelBatch => ({
  ownerName: items[0]?.ownerName ?? '',
  programName: items[0]?.programName ?? '',
  labels: items.map((l) => ({ id: l.cylinderId, serialNo: l.serialNo, qrPayload: l.qrPayload, manufacturerSerial: l.manufacturerSerial })),
});
/** POST /cylinders/labels {ids}: the labels found (those out of scope or unknown come back in `missing`). */
export const fetchCylinderLabels = (ids: number[]) => send<{ items: WireLabel[]; missing: number[] }>('/cylinders/labels', { ids }).then((r) => toBatch(r.items));
export const fetchCylinderLabel = (id: number) => api<WireLabel>(`/cylinders/${id}/label`).then((l) => toBatch([l]));
